import React from 'react'
import { map, size } from 'lodash'
import { Button, Label } from 'semantic-ui-react'

const options = [
  {key: 1, text: 'All', value: 'all'},
  {key: 2, text: 'Instant Orders', value: 'instantOrders'},
  {key: 3, text: 'Same-Day Orders', value: 'sameDayOrders'},
]

export default class ExpressTabOrder extends React.PureComponent {
  renderOption = option => {
    const { activeTab, onChange, express } = this.props

    const orders = express[option.value] || {}
    const orderCount = size(orders)

    return (
      <Button
        onClick={() => onChange(option)}
        key={option.key}
        basic={option.value !== activeTab}
        color="black"
      >
        {option.text}
        <Label style={{ position: 'relative', marginLeft: 5 }} color="grey" circular>
          {orderCount}
        </Label>
      </Button>
    )
  }

  render() {
    return <Button.Group fluid>{map(options, this.renderOption)}</Button.Group>
  }
}


// WEBPACK FOOTER //
// ./src/containers/express/components/ExpressTabBar.js